import React from "react";
import EmptyState from "../EmptyState";

const DataTable = ({ columns, data, loading, emptyTitle, emptyDescription, onRowClick }) => {
  if (loading) {
    return (
      <div className="neumorphic-card rounded-2xl p-6 space-y-3 animate-pulse">
        <div className="h-5 bg-gray-200 dark:bg-white/5 rounded w-1/4" />
        <div className="h-8 bg-gray-200 dark:bg-white/5 rounded w-full" />
        <div className="h-8 bg-gray-200 dark:bg-white/5 rounded w-full" />
        <div className="h-8 bg-gray-200 dark:bg-white/5 rounded w-full" />
      </div>
    );
  }

  if (!data || data.length === 0) {
    return <EmptyState title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className="neumorphic-card rounded-2xl overflow-hidden">
      <div className="overflow-x-auto custom-scrollbar">
        <table className="w-full text-left border-collapse table-auto">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/5 bg-gray-50 dark:bg-white/[0.02]">
              {columns.map((col, idx) => (
                <th
                  key={col.key || idx}
                  className="px-3.5 py-3 text-[11px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider whitespace-nowrap"
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-white/5 text-xs font-medium">
            {data.map((row, rowIndex) => (
              <tr
                key={row.id || rowIndex}
                onClick={() => onRowClick && onRowClick(row)}
                className={`transition-colors hover:bg-purple-50 dark:hover:bg-purple-500/5 ${onRowClick ? "cursor-pointer" : ""}`}
              >
                {columns.map((col, colIndex) => (
                  <td key={col.key || colIndex} className="px-3.5 py-2.5 text-gray-800 dark:text-gray-200">
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
